var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDownloadSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16C20 15.4477 19.5523 15 19 15C18.4477 15 18 15.4477 18 16V19.5858L17.7071 19.2929C17.3166 18.9024 16.6834 18.9024 16.2929 19.2929C15.9024 19.6834 15.9024 20.3166 16.2929 20.7071L18.2929 22.7071C18.6834 23.0976 19.3166 23.0976 19.7071 22.7071L21.7071 20.7071C22.0976 20.3166 22.0976 19.6834 21.7071 19.2929C21.3166 18.9024 20.6834 18.9024 20.2929 19.2929L20 19.5858V16Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.2C12.48 2 12.62 2 12.727 2.0545C12.8211 2.10243 12.8976 2.17892 12.9455 2.273C13 2.37996 13 2.51997 13 2.8V5C13 7.20914 14.7909 9 17 9H19.2C19.48 9 19.62 9 19.727 9.0545C19.8211 9.10243 19.8976 9.17892 19.9455 9.273C20 9.37996 20 9.51997 20 9.8V12.2C20 12.48 20 12.62 19.9455 12.727C19.8976 12.8211 19.8211 12.8976 19.727 12.9455C19.62 13 19.48 13 19.2 13H19C15.6863 13 13 15.6863 13 19V21.2C13 21.48 13 21.62 12.9455 21.727C12.8976 21.8211 12.8211 21.8976 12.727 21.9455C12.62 22 12.48 22 12.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8Z",
    fill: "#6B92FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.70711C15 2.31658 15.3166 2 15.7071 2C15.8946 2 16.0745 2.0745 16.2071 2.20711L19.7929 5.79289C19.9255 5.9255 20 6.10536 20 6.29289C20 6.68342 19.6834 7 19.2929 7H17C15.8954 7 15 6.10457 15 5V2.70711Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownloadSolid);
export default __webpack_public_path__ + "static/media/FileDownloadSolid.d0bf382d.svg";
export { ForwardRef as ReactComponent };